import script from "./EarnMorePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EarnMorePanel.vue?vue&type=script&setup=true&lang=js"

import "./EarnMorePanel.vue?vue&type=style&index=0&id=6673877a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6673877a"]])

export default __exports__